import * as React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';

import { ContainerOne } from 'elements/components/Containers';
import { Funder } from 'labxchange-client';
import messages from 'library/displayMessages';
import { WrappedMessage } from 'utils';
import { UILanguages } from 'i18n';

interface FundersListProps {
  funders: Funder[];
}

const HINDI = 'hi';

const FundersListBase: React.FC<FundersListProps> = ({ funders }) => {
  const { locale } = useIntl();

  if (funders.length === 0) return null;

  const isHindi = locale in UILanguages && locale === HINDI;
  const classNamesStr = classNames('item-funders', {
    'item-funders-one': funders.length === 1,
    rtl: isHindi,
  });

  return (
    <ContainerOne>
      <div className={classNamesStr}>
        <div className='item-funders-title'>
          <WrappedMessage message={messages.fundersListTitle} />
        </div>
        <ol className='item-funders-list'>
          {funders.map((funder, idx) => (
            <li className='item-funders-list-item' key={idx}>
              <img src={funder.largeLogoUrl} alt={funder.name} />
            </li>
          ))}
        </ol>
      </div>
    </ContainerOne>
  );
};

export const FundersList = React.memo(FundersListBase);
